import { usePathname } from 'next/navigation'

const useIsBiometricConsentPage = () => {
  const pathName = usePathname()
  return pathName === '/biometric-consent' || pathName === '/biometric-consent/'
}

export default useIsBiometricConsentPage
